import { Actions } from 'vuex-smart-module';
import { Filters, FiltersPagination } from '@/types';
import RetroBonusesState from './state';
import RetroBonusesMutations from './mutations';
import RetroBonusesGetters from './getters';
import { RetroBonusesService } from '../services';
import { RetroBonuses } from '../types';

const retroBonusesService = new RetroBonusesService();

export default class RetroBonusesActions extends Actions<
  RetroBonusesState,
  RetroBonusesGetters,
  RetroBonusesMutations,
  // eslint-disable-next-line no-use-before-define
  RetroBonusesActions
> {
  async get_retro_bonuses() {
    try {
      const {
        sortBy = [], sortDesc = [], page = 1, itemsPerPage = 10,
      } = this.state.table_options;

      const payload: FiltersPagination<Filters> = {
        filters: this.state.filters,
        pagination: {
          limit: itemsPerPage,
          page,
          sort: '',
          sort_type: 'asc',
        },
      };

      if (sortBy?.length) {
        [payload.pagination.sort] = sortBy;
      }

      if (sortDesc?.length) {
        payload.pagination.sort_type = sortDesc[0] ? 'desc' : 'asc';
      }

      this.mutations.TOGGLE_RETRO_BONUSES_LOADING(true);
      const { data, meta } = await retroBonusesService.get_retro_bonuses(payload);

      this.mutations.SET_RETRO_BONUSES(data.items);
      this.mutations.SET_ORGANIZATIONS(data.organizations);
      this.mutations.UPD_TABLE_OPTIONS({ key: 'itemsPerPage', value: meta.limit });
      this.mutations.UPD_TABLE_OPTIONS({ key: 'page', value: meta.current_page });
      this.mutations.UPD_PAGINATION_FIELD({ key: 'current_page', value: meta.current_page });
      this.mutations.UPD_PAGINATION_FIELD({ key: 'total_pages', value: meta.total_pages });
      this.mutations.UPD_PAGINATION_FIELD({ key: 'total_items', value: meta.total_items });
      this.mutations.UPD_PAGINATION_FIELD({ key: 'limit', value: meta.limit });
    } catch (error) {
      console.error(error);
    } finally {
      this.mutations.TOGGLE_RETRO_BONUSES_LOADING(false);
    }
  }

  async get_rewards_documents_by_id(id: string | number) {
    try {
      const {
        sortBy = [], sortDesc = [], page = 1, itemsPerPage = 10,
      } = this.state.table_options;

      const payload: FiltersPagination<Filters> = {
        filters: this.state.reward_documents_filters,
        pagination: {
          limit: itemsPerPage,
          page,
          sort: '',
          sort_type: 'asc',
        },
      };

      if (sortBy?.length) {
        [payload.pagination.sort] = sortBy;
      }

      if (sortDesc?.length) {
        payload.pagination.sort_type = sortDesc[0] ? 'desc' : 'asc';
      }

      this.mutations.TOGGLE_RETRO_BONUSES_LOADING(true);
      const { data, meta } = await retroBonusesService.get_rewards_documents_by_id(id, payload);

      this.mutations.SET_REWARD_DOCUMENTS(data.items);
      this.mutations.SET_SCENARIOS(data.scenarios);
      this.mutations.SET_CONTRACT_INFO(data.contract);

      this.mutations.UPD_TABLE_OPTIONS({ key: 'itemsPerPage', value: meta.limit });
      this.mutations.UPD_TABLE_OPTIONS({ key: 'page', value: meta.current_page });
      this.mutations.UPD_PAGINATION_FIELD({ key: 'current_page', value: meta.current_page });
      this.mutations.UPD_PAGINATION_FIELD({ key: 'total_pages', value: meta.total_pages });
      this.mutations.UPD_PAGINATION_FIELD({ key: 'total_items', value: meta.total_items });
      this.mutations.UPD_PAGINATION_FIELD({ key: 'limit', value: meta.limit });
    } catch (error) {
      console.error(error);
    } finally {
      this.mutations.TOGGLE_RETRO_BONUSES_LOADING(false);
    }
  }

  async get_reward_document_by_id(id: string | number) {
    try {
      const { data } = await retroBonusesService.get_reward_document_by_id(id);

      this.mutations.SET_REWARD_DOCUMENT_DETAIL(data as RetroBonuses.RewardDocumentDetail);
    } catch (error) {
      console.error(error);
    }
  }

  async get_reward_document_products_by_id(id: string | number) {
    try {
      const {
        sortBy = [], sortDesc = [], page = 1, itemsPerPage = 10,
      } = this.state.table_options;

      const payload: FiltersPagination<Filters> = {
        filters: this.state.reward_documents_filters,
        pagination: {
          limit: itemsPerPage,
          page,
          sort: '',
          sort_type: 'asc',
        },
      };

      if (sortBy?.length) {
        [payload.pagination.sort] = sortBy;
      }

      if (sortDesc?.length) {
        payload.pagination.sort_type = sortDesc[0] ? 'desc' : 'asc';
      }

      this.mutations.TOGGLE_RETRO_BONUSES_LOADING(true);
      const { data, meta } = await retroBonusesService.get_reward_document_products_by_id(id, payload);

      this.mutations.SET_REWARD_DOCUMENT_PRODUCTS(data.items);

      this.mutations.UPD_TABLE_OPTIONS({ key: 'itemsPerPage', value: meta.limit });
      this.mutations.UPD_TABLE_OPTIONS({ key: 'page', value: meta.current_page });
      this.mutations.UPD_PAGINATION_FIELD({ key: 'current_page', value: meta.current_page });
      this.mutations.UPD_PAGINATION_FIELD({ key: 'total_pages', value: meta.total_pages });
      this.mutations.UPD_PAGINATION_FIELD({ key: 'total_items', value: meta.total_items });
      this.mutations.UPD_PAGINATION_FIELD({ key: 'limit', value: meta.limit });
    } catch (error) {
      console.error(error);
    } finally {
      this.mutations.TOGGLE_RETRO_BONUSES_LOADING(false);
    }
  }
}
